// assets/ssr-tracking.js
(function(){
  if (!window.SSR_CONFIG) return;
  const WORKER_ENDPOINT = window.SSR_CONFIG.endpoint;
  const CURRENCY = window.SSR_CONFIG.currency;

  function getCookie(name){
    const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : undefined;
  }
  function getFbc(){
    try{
      const params = new URLSearchParams(location.search);
      const fbclid = params.get('fbclid');
      if (!fbclid) return undefined;
      return `fb.1.${Math.floor(Date.now()/1000)}.${fbclid}`;
    }catch{ return undefined; }
  }

  async function postEvent(evt){
    try{
      await fetch(WORKER_ENDPOINT, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          event_name: evt.name,
          event_time: Math.floor(Date.now()/1000),
          event_id: (crypto?.randomUUID && crypto.randomUUID()) || String(Date.now())+Math.random().toString(16).slice(2),
          event_source_url: location.href,
          user_data: window.SSR_CONFIG.user_data || {},
          custom_data: evt.data || {},
          fbp: getCookie("_fbp"),
          fbc: getCookie("_fbc") || getFbc(),
          test_event_code: window.SSR_CONFIG.test_event_code || undefined
        })
      });
    }catch(e){ console?.warn?.("CAPI post failed", e); }
  }

  // Define once
  if (!window.ssrTrack){
    window.ssrTrack = function(name, data){ postEvent({ name, data }); };
  }

  // 1) PageView on every page
  window.ssrTrack("PageView");

  // 2) ViewContent on product pages
  if (window.SSR_CONFIG.product){
    const p = window.SSR_CONFIG.product;
    window.ssrTrack("ViewContent", {
      content_type: "product",
      content_ids: [String(p.id)],
      content_name: p.title,
      value: p.price,
      currency: CURRENCY
    });
  }

  // 3) AddToCart hooks (watch /cart/add via fetch and XHR)
  (function(){
    const fireATC = (payload) => window.ssrTrack("AddToCart", payload);

    const _fetch = window.fetch;
    window.fetch = async function(input, init){
      const res = await _fetch(input, init);
      try{
        const url = (typeof input === 'string') ? input : (input?.url || "");
        if (url.includes('/cart/add')){
          res.clone().json().then(data=>{
            const line = Array.isArray(data?.items) ? data.items[0] : data;
            if (line){
              fireATC({
                content_type: "product",
                content_ids: [String(line.product_id || line.id)],
                value: (line.final_price || line.price || 0)/100,
                currency: CURRENCY,
                contents: [{
                  id: String(line.product_id || line.id),
                  quantity: line.quantity || 1,
                  item_price: (line.final_price || line.price || 0)/100
                }]
              });
            }
          }).catch(()=>{});
        }
      }catch{}
      return res;
    };

    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__isCartAdd = (typeof url === 'string' && url.includes('/cart/add'));
      return _open.apply(this, arguments);
    };
    const _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function(){
      this.addEventListener('load', function(){
        if (this.__isCartAdd){
          try{
            const data = JSON.parse(this.responseText);
            const line = Array.isArray(data?.items) ? data.items[0] : data;
            if (line){
              fireATC({
                content_type: "product",
                content_ids: [String(line.product_id || line.id)],
                value: (line.final_price || line.price || 0)/100,
                currency: CURRENCY,
                contents: [{
                  id: String(line.product_id || line.id),
                  quantity: line.quantity || 1,
                  item_price: (line.final_price || line.price || 0)/100
                }]
              });
            }
          }catch{}
        }
      });
      return _send.apply(this, arguments);
    };
  })();

  // 4) InitiateCheckout on checkout clicks
  document.addEventListener('click', (e)=>{
    const el = e.target.closest('[href*="/checkout"], button[name="checkout"]');
    if (!el) return;
    try{
      fetch('/cart.js').then(r=>r.json()).then(cart=>{
        window.ssrTrack("InitiateCheckout", {
          value: cart.total_price/100,
          currency: CURRENCY,
          num_items: cart.item_count,
          contents: cart.items.map(i => ({
            id: String(i.product_id),
            quantity: i.quantity,
            item_price: i.price/100
          }))
        });
      });
    }catch{}
  });

})();
